import React, { useState } from "react";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import "./DashboardProfileStyles.css";
import OrderForm from "./OTC/OrderForm";

export const DashboardOTC = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="relative flex min-h-screen w-full lg:ml-[10px]" data-testid="container-dashboard-otc-container">
      <Topbar />
      <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      {isSidebarOpen && (
        <div
          onClick={toggleSidebar}
          className="fixed inset-0 bg-black opacity-50 z-20"
          data-testid="nav-overlay"
        ></div>
      )}
      <div className={`flex-grow flex flex-col ${isSidebarOpen ? "z-10" : ""}`} data-testid="container-content-wrapper">
        <div className="flex flex-col items-center justify-center flex-grow pt-2 w-full" data-testid="container-content-container">
          <div className="relative w-full lg:min-w-[1200px] lg:ml-[-230px] mx-auto" data-testid="container-layout-container">
            <div className="p-7 sm:p-8 md:px-12 md:pt-1 mt-2 md:mt-8 w-full" data-testid="container-inner-container">
              <h1 className="text-3xl font-normal text-left ml-10 mb-8 text-black dark:text-white lg:mt-12 md:ml-[40px] mt-10" data-testid="container-title"></h1>
              <div className=" overflow-y-auto lg:overflow-hidden hide-scrollbar" data-testid="container-form-container">
                <OrderForm />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardOTC;

/*
POTENTIAL IMPROVEMENTS:
1. Add a proper title to the h1 element (currently empty)
2. Consider implementing a responsive design that works better on mobile devices
3. Add proper loading states for OTC data
4. Implement error handling for failed OTC data fetching
5. Consider adding form validation feedback for the order form
6. Add proper keyboard navigation for the OTC interface
7. Consider adding a confirmation step before submitting OTC orders
8. Implement proper aria attributes for better screen reader support
9. Add informational tooltips for complex OTC concepts
10. Consider adding a recent orders section for quick reference
*/
